import { gql } from "@apollo/client";

export const GET_CARD_PRESET = gql`
  query cardPreset($id: ID!) {
    cardPreset(id: $id) {
      id
      presetName
      transactionLimit
      dailyLimit
      weeklyLimit
      monthlyLimit
      totalLimit
      expenseCategoryData {
        id
        name
      }
      allocationData {
        key
        name
        id
        allocationCode
      }
      receiptPolicy
      allocationPolicy
      cancellationTimeFrame {
        timeFrameValue
        timeFrameFrequency
      }
      allowedMerchants {
        id
        name
        logo
        cachedLogo
      }
      allowedCategories {
        id
        name
      }
      blockedMerchants {
        id
        name
        logo
        cachedLogo
      }
      blockedCategories {
        id
        name
      }
    }
  }
`;

export const GET_CARD_PRESETS = gql`
  query cardPresets($first: Int, $after: String, $before: String) {
    cardPresets(first: $first, after: $after, before: $before) {
      edges {
        cursor
        node {
          id
          presetName
          transactionLimit
          dailyLimit
          weeklyLimit
          monthlyLimit
          totalLimit
          expenseCategoryData {
            id
            name
          }
          allocationData {
            key
            name
            id
            allocationCode
          }
          receiptPolicy
          allocationPolicy
          cancellationTimeFrame {
            timeFrameValue
            timeFrameFrequency
          }
          allowedMerchants {
            id
            name
            logo
            cachedLogo
          }
          allowedCategories {
            id
            name
          }
          blockedMerchants {
            id
            name
            logo
            cachedLogo
          }
          blockedCategories {
            id
            name
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        total
      }
    }
  }
`;

export const ADD_CARD_PRESET = gql`
  mutation addCardPreset($input: AddCardPresetInput) {
    addCardPreset(input: $input) {
      id
    }
  }
`;

export const UPDATE_CARD_PRESET = gql`
  mutation updateCardPreset($id: ID!, $input: UpdateCardPresetInput) {
    updateCardPreset(id: $id, input: $input) {
      id
    }
  }
`;

export const DELETE_CARD_PRESET = gql`
  mutation deleteCardPreset($id: ID!) {
    deleteCardPreset(id: $id) {
      id
    }
  }
`;
